'use client'

import React from 'react'

type Props = {
    semiAxisA: number
    semiAxisB: number
    semiAxisC: number
}

const WIDTH = 340
const HEIGHT = 220

export default function EllipsoidChart({ semiAxisA, semiAxisB, semiAxisC }: Props) {
    const maxDim = Math.max(semiAxisA, semiAxisB, semiAxisC, 0.0001)
    const scale = 90 / maxDim
    const rx = Math.max(semiAxisA * scale, 24)
    const ry = Math.max(semiAxisB * scale, 24)
    const rc = Math.max(semiAxisC * scale, 18)

    const cx = WIDTH / 2
    const cy = HEIGHT / 2

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* c-axis ellipse (depth, suggested going into the page) */}
            <ellipse cx={cx} cy={cy} rx={rc} ry={ry} fill="none" stroke="#2563eb" strokeWidth={1.2} opacity={0.5} />
            {/* main a-b ellipse */}
            <ellipse cx={cx} cy={cy} rx={rx} ry={ry} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            {/* equator line */}
            <ellipse cx={cx} cy={cy} rx={rx} ry={ry * 0.32} fill="none" stroke="#2563eb" strokeWidth={1.2} opacity={0.5} />

            <line x1={cx} y1={cy} x2={cx + rx} y2={cy} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + rx / 2} y={cy + 16} fontSize={11} textAnchor="middle" fill="#dc2626">a = {semiAxisA.toFixed(2)}</text>

            <line x1={cx} y1={cy} x2={cx} y2={cy - ry} stroke="#16a34a" strokeWidth={1.5} />
            <text x={cx + 6} y={cy - ry / 2} fontSize={11} fill="#16a34a">b = {semiAxisB.toFixed(2)}</text>

            <line x1={cx} y1={cy} x2={cx - rc * 0.7} y2={cy + ry * 0.55} stroke="#9333ea" strokeWidth={1.5} />
            <text x={cx - rc * 0.7 - 6} y={cy + ry * 0.55 + 14} fontSize={11} textAnchor="end" fill="#9333ea">c = {semiAxisC.toFixed(2)}</text>
        </svg>
    )
}
